module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('hello'), _vm._v(" "), _c('onboarding-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e9bff48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 61
// module chunks = 2